import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 1px 0 #e2ebf6',
    marginBottom: '30px'
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    padding: '15px 0 13px',
    borderBottom: '2px solid transparent',
    fontSize: '13px',
    lineHeight: '18px',
    color: '#59758b',
    marginRight: '20px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  selected: {
    color: '#000000',
    fontWeight: '500',
    borderBottom: '2px solid #0e8bb4',
    '&:hover': {
      cursor: 'default'
    }
  },
  closeBtn: {
    color: '#59758b',
    fontSize: '13px',
    marginLeft: '4px',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  addBtn: {
    color: '#0e8bb4',
    fontSize: '20px',
    '&:hover': {
      cursor: 'pointer'
    }
  }
});
